import React, { Component } from "react";
import ArrowImage from "../../assets/images/arrowenabled.svg";
import ContentWrapper from "../Layout/ContentWrapper";
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  Label,
  Row,
  Button,
} from "reactstrap";
import InfoWrapper from "../Common/InfoWrapper";

export default class CommandConfig extends Component {
  state = {
    enableCommand: 0, // 0 = false, 1 = true
  };

  setValues = (field, value) => {
    this.setState({ [field]: value });
  };

  saveSettings = () => {
    const { enableCommand } = this.state;
    console.log("Salvando configurações...");
  
    // {Implementar verificação de comandas em abertas, caso tenha, não deverá permitir desabilitar o controle de comandas}
  };

  render() {
    const { enableCommand } = this.state;
    return (
      <ContentWrapper>
        <div className="content-heading">Controle de Comandas</div>
        <Card className="b">
          <CardBody style={{ paddingBottom: "0px" }}>
            <Row>
              <Col>
                <label className="switch">
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      this.setValues("enableCommand", e.target.checked ? 1 : 0);
                      console.log("Controle de Comandas = " + e.target.checked);
                    }}
                    checked={!!enableCommand}
                  />
                  <span></span>
                  <label className="m-2 text-bold">
                    Controle de Comandas{"   "}
                    <InfoWrapper>
                      Você poderá desabilitar a qualquer momento, desde que não
                      tenha nenhuma comada aberta.
                    </InfoWrapper>
                  </label>
                </label>
              </Col>
              <Row>
                <Col>
                  <div className="card b m-3">
                    <Row className="m-4">
                      <Col className="text-wrap text-center">
                        A cada novo agendamento, uma{" "}
                        <strong className="text-success">comanda</strong> é
                        automaticamente criada e vinculada ao cliente — e pode
                        ser visualizada a qualquer momento na aba{" "}
                        <strong>"Comandas"</strong> do menu{" "}
                        <strong>"Agenda"</strong>.
                      </Col>
                      <Col md={1} className="d-flex align-items-center">
                        <img src={ArrowImage} />
                      </Col>
                      <Col className="text-wrap text-center">
                        Todos os serviços realizados e novos agendamentos
                        vinculados ao mesmo cliente são registrados
                        automaticamente na comanda em aberto, garantindo
                        controle unificado e atualização.
                      </Col>
                      <Col md={1} className="d-flex align-items-center">
                        <img src={ArrowImage} />
                      </Col>
                      <Col className="text-wrap text-center">
                        No momento do fechamento da comanda, você tem uma visão
                        completa de todos os serviços e produtos registrados,
                        podendo realizar o lançamento do pagamento de forma
                        simples e eficiente.
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Row>
          </CardBody>
          <CardFooter>
            <Row>
              <Col className="text-right m-2">
                <Button color="success" onClick={this.saveSettings}>
                  Salvar
                </Button>
              </Col>
            </Row>
          </CardFooter>
        </Card>
      </ContentWrapper>
    );
  }
}
